export default __webpack_public_path__ + "static/media/paperclip.fbc1b083.svg";